import React from "react";
import "./hsm.css";
import {
  ShieldCheck,
  FileText,
  Database,
  RefreshCcw,
  Settings
} from "lucide-react";
import {
 LineChart,
 Line,
 XAxis,
 YAxis,
 CartesianGrid,
 Tooltip,
 Legend,
 ResponsiveContainer
} from "recharts";


export default function HSMDashboard() {


const devices = [
  {
    name:"Luna HSM 7",
    vendor:"Thales",
    type:"Network HSM",
    location:"Data Center 1",
    status:"Healthy",
    usage:"45%"
  },
  {
    name:"AWS CloudHSM",
    vendor:"AWS",
    type:"Cloud HSM",
    location:"AWS us-east-1",
    status:"Healthy",
    usage:"32%"
  },
  {
    name:"Azure Key Vault HSM",
    vendor:"Microsoft",
    type:"Cloud HSM",
    location:"Azure East US",
    status:"Healthy",
    usage:"28%"
  },
  {
    name:"Utimaco CryptoServer",
    vendor:"Utimaco",
    type:"Network HSM",
    location:"Data Center 2",
    status:"Healthy",
    usage:"38%"
  }
]


return (

<div className="hsm-page">

<div className="hsm-layout">


{/* LEFT */}


<div className="hsm-main">



<div className="top-cards">


<div className="hsm-card overview-card">

    <h4>HSM Overview</h4>


    <div className="overview-content">


        <div className="circle-wrapper">

            <div className="circle">

                <span>4</span>
                <small>Total HSMs</small>

            </div>

        </div>



        <div className="status-list">


            <div>
                <span className="dot healthy-dot"></span>
                Healthy
            </div>


            <div>
                <span className="dot warning-dot"></span>
                Warning
            </div>


            <div>
                <span className="dot critical-dot"></span>
                Critical
            </div>


            <div>
                <span className="dot offline-dot"></span>
                Offline
            </div>


        </div>


    </div>


</div>




<div className="hsm-card chart-card">

<h4>HSM Health</h4>

<div className="health-chart">

<ResponsiveContainer width="100%" height="100%">

<LineChart
margin={{top:10, right:20, left:0, bottom:0}}
data={[
{day:"May 9", luna:88,aws:45,azure:36,utimaco:62},
{day:"May 10",luna:96,aws:58,azure:34,utimaco:85},
{day:"May 11",luna:88,aws:58,azure:36,utimaco:75},
{day:"May 12",luna:96,aws:58,azure:32,utimaco:75},
{day:"May 13",luna:78,aws:50,azure:31,utimaco:68},
{day:"May 14",luna:88,aws:60,azure:36,utimaco:88},
{day:"May 15",luna:88,aws:60,azure:36,utimaco:80}
]}
>


<CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0"/>

<XAxis dataKey="day" tick={{fontSize:11,fill:"#94a3b8"}} axisLine={false} tickLine={false}/>

<YAxis domain={[0,100]} tickFormatter={(v)=>`${v}%`} tick={{fontSize:11,fill:"#94a3b8"}} axisLine={false} tickLine={false}/>

<Tooltip formatter={(v,n)=>[`${v}%`,n]} contentStyle={{fontSize:12,borderRadius:8,border:"1px solid #e2e8f0"}}/>

<Line type="monotone" dataKey="luna" stroke="#2563eb" strokeWidth={2} dot={{r:3}} name="Luna HSM 7"/>

<Line type="monotone" dataKey="aws" stroke="#f59e0b" strokeWidth={2} dot={{r:3}} name="AWS CloudHSM"/>

<Line type="monotone" dataKey="azure" stroke="#ef4444" strokeWidth={2} dot={{r:3}} name="Azure Key Vault HSM"/>

<Line type="monotone" dataKey="utimaco" stroke="#22c55e" strokeWidth={2} dot={{r:3}} name="Utimaco CryptoServer"/>

<Legend iconType="circle" iconSize={8} wrapperStyle={{fontSize:11,paddingTop:6}}/>



</LineChart>


</ResponsiveContainer>


</div>


</div>
</div>


<div className="hsm-card devices-card">


<h4>HSMs</h4>


<table className="hsm-table">


<thead>

<tr>

<th>HSM Name</th>
<th>Vendor</th>
<th>Type</th>
<th>Location</th>
<th>Status</th>
<th>Utilization</th>
<th>Actions</th>

</tr>

</thead>



<tbody>

{devices.map((d) => (

<tr key={d.name}>

<td>{d.name}</td>

<td>{d.vendor}</td>

<td>{d.type}</td>

<td>{d.location}</td>


<td>
<span className={`status ${d.status.toLowerCase()}`}>
{d.status}
</span>
</td>


<td>

<div className="usage">

<div className="usage-bar">

<div 
style={{width:d.usage}}
></div>

</div>

<span>{d.usage}</span>

</div>

</td>


<td>

<button className="action-btn">
...
</button>

</td>


</tr>

))}



</tbody>


</table>


</div>
</div>






{/* RIGHT PANEL */}


<div className="side-panel">


<div className="hsm-card details-card">


<h4>HSM Details</h4>


<h4 className="device-title">
    Luna HSM 7
</h4>



<div className="detail-row">

<span>Vendor</span>
<strong>Thales</strong>

</div>


<div className="detail-row">

<span>Model</span>
<strong>Luna Network HSM 7</strong>

</div>


<div className="detail-row">

<span>Serial No</span>
<strong>7A8B-3C4D-56EF</strong>

</div>


<div className="detail-row">

<span>Firmware Version</span>
<strong>7.1.0</strong>

</div>



<div className="detail-row">

<span>Partitions</span>
<strong>10</strong>

</div>



<div className="detail-row">

<span>Total Capacity</span>
<strong>100%</strong>

</div>



<div className="capacity-box">


<div className="capacity-title">

<span>Used Capacity</span>

<strong>45%</strong>

</div>



<div className="capacity-bar">


<div 
className="capacity-fill"
style={{width:"45%"}}
></div>


</div>


</div>



</div>





<div className="hsm-card actions-card">


<h4>HSM Actions</h4>


<div className="action-grid">


<div className="action-item">

<div className="action-icon">

<ShieldCheck/>

</div>

<span>View Logs</span>

</div>




<div className="action-item">

<div className="action-icon">

<FileText/>

</div>

<span>Backup</span>

</div>





<div className="action-item">

<div className="action-icon">

<Database/>

</div>

<span>Certificate Store</span>

</div>





<div className="action-item">

<div className="action-icon">

<RefreshCcw/>

</div>

<span>Performance</span>

</div>





<div className="action-item">

<div className="action-icon">

<Settings/>

</div>

<span>Settings</span>

</div>


</div>


</div>


</div>



</div>


</div>

)

}